<template>
  <div class="banner">
          <img src="@/assets/images/newfolder/5.png" alt="公司首页 banner"  style=" width: 1715px;height: 400px;"/>

     <!-- <el-carousel :interval="5000" arrow="always" height="600px" >
       <el-carousel-item >
          <img :src="'../assets/images/banner/banner5.png'" alt="公司首页 banner" />
        </el-carousel-item>
      </el-carousel> -->
  <div class="train-cleaning-section">
    
    <!-- <div class="section-header">
      <h1>列车专业保洁服务</h1>
      <p>专注列车深度清洁，涵盖车厢内饰、空调系统、卫生设施等全场景，保障乘车环境安全舒适</p>
    </div> -->
    <div class="module-nav">
      <router-link :to="{ name: 'CompanyProfile' }" class="nav-item">公司简介</router-link>
      <router-link :to="{ name: 'ServiceConcept' }" class="nav-item">服务理念</router-link>
      <router-link :to="{ name: 'BusinessAdvantages' }" class="nav-item">经营优势</router-link>
      <router-link :to="{ name: 'CompanyScale' }" class="nav-item">公司规模</router-link>
      <router-link :to="{ name: 'DevelopmentHistory' }" class="nav-item">光辉历程</router-link>
    </div>
    <router-view></router-view>
  </div>
</div>
</template>

<script>
export default {
  name: 'About'
};
</script>

<style scoped>
.banner img {
  width: 100%;
  height: 600px;
  /* object-fit: cover; */
}
.train-cleaning-section {
  max-width: 1440px;
  margin: 40px auto;
  padding: 30px 40px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.section-header {
  margin-bottom: 20px;
  text-align: center;
}

.module-nav {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 40px;
}

.module-nav .nav-item {
  padding: 12px 24px;
  font-size: 1.1em;
  color: #34495e;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  text-decoration: none;
  transition: all 0.3s;
}

.module-nav .nav-item:hover {
  color: #42b983;
  border-color: #42b983;
}

.module-nav .nav-item.router-link-exact-active {
  background-color: #42b983;
  color: white;
  border-color: #42b983;
}

.section-header h1 {
  color: #2c3e50;
  font-size: 2.2em;
  margin-bottom: 15px;
}

.section-header p {
  color: #666;
  font-size: 1.1em;
  line-height: 1.6;
}

.service-intro {
  margin-bottom: 50px;
}

.service-intro h2 {
  color: #34495e;
  font-size: 1.8em;
  margin-bottom: 20px;
}

.service-intro ul {
  list-style: none;
  padding-left: 20px;
}

.service-intro li {
  color: #444;
  font-size: 1.1em;
  line-height: 1.8;
  margin-bottom: 12px;
  position: relative;
}

.service-intro li::before {
  content: "•";
  color: #42b983;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.case-show h2 {
  color: #34495e;
  font-size: 1.8em;
  margin-bottom: 25px;
}

.case-slider {
  display: flex;
  justify-content: center;
  gap: 30px;
  overflow-x: auto;
  padding: 20px 0;
}

.case-item {
  flex: 0 0 45%;
  min-width: 300px;
  text-align: center;
}

.case-item img {
  width: 100%;
  height: 240px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.case-item p {
  color: #666;
  margin-top: 10px;
  font-size: 1em;
  }
</style>